import {BackendData} from "@app/_model/backend.data";
import {Account} from "@app/_model";
import {AccountClient} from "@app/_model/account.client";

export class Client extends BackendData {
  name: string;
  adoszam?: string;
  email: string;

  accountClients: AccountClient[];

  constructor(
    id: number,
    inserted: Date | undefined,
    insertedBy: Account | undefined,
    updated: Date | undefined,
    updatedBy: Account | undefined,
    name: string,
    adoszam: string | undefined,
    email: string,
    accountClients: AccountClient[]
  ) {
    super(id, inserted, insertedBy, updated, updatedBy);
    this.name = name;
    this.adoszam = adoszam;
    this.email = email;
    this.accountClients = accountClients;
    this.log.trace('Client:', this);
  }

  public static of(client: Client | any): Client {
    return new Client(client.id, client.inserted, client.insertedBy, client.updated, client.updatedBy, client.name, client.adoszam, client.email, client.accountClients);
  }
}
